import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=6965c524&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6965c524')) {
      api.createRecord('6965c524', component.options)
    } else {
      api.reload('6965c524', component.options)
    }
    module.hot.accept("./DropdownButton.vue?vue&type=template&id=6965c524&", function () {
      api.rerender('6965c524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DropdownButton.vue"
export default component.exports